import React from "react";
import Home from "./components/Home/Home";
import SignIn from "./components/SignIn/SignIn";

const App = () => {
  return <>{localStorage.getItem("jwtToken") ? <Home /> : <SignIn />}</>;
};

export default App;
